// Observe the flow once, rather than retaining every image node. Coalesce
// asynchronous images, fonts and DOM changes into one layout read per frame.
export default function observeHandoutFlow(flow, onMeasure) {
  if (!flow) return () => {};
  let frame;
  let disposed = false;
  const schedule = () => {
    if (disposed || frame !== undefined) return;
    frame = window.requestAnimationFrame(() => {
      frame = undefined;
      if (!disposed) onMeasure();
    });
  };
  const resize = typeof ResizeObserver === "undefined" ? null : new ResizeObserver(schedule);
  resize?.observe(flow);
  const mutations = typeof MutationObserver === "undefined" ? null : new MutationObserver(schedule);
  mutations?.observe(flow, { childList: true, subtree: true, characterData: true, attributes: true,
    attributeFilter: ["src", "width", "height", "style", "class", "data-handout-image-size"] });
  flow.addEventListener("load", schedule, true);
  flow.addEventListener("error", schedule, true);
  window.addEventListener("resize", schedule);
  document.fonts?.addEventListener?.("loadingdone", schedule);
  document.fonts?.ready?.then(schedule).catch(() => {});
  schedule();
  return () => {
    disposed = true;
    if (frame !== undefined) window.cancelAnimationFrame(frame);
    resize?.disconnect(); mutations?.disconnect();
    flow.removeEventListener("load", schedule, true);
    flow.removeEventListener("error", schedule, true);
    window.removeEventListener("resize", schedule);
    document.fonts?.removeEventListener?.("loadingdone", schedule);
  };
}
